module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo2-07645e701821b5d758921d1a3502ddaf.jpg";